import styled from "styled-components";
import { useAppSelector } from "../../../../../../../redux";
import { FlexRowEnd } from "../../../../../../Common/Styles";
import { FooterButtons } from "./Buttons";
import { TweakYourFeed } from "./TweakYourFeed";

export const Footer = () => {
  const { reportPostStep } = useAppSelector((state) => state.reportPost);

  const showTweakYourFeed = reportPostStep === "why_reporting";
  const showBackButton =
    reportPostStep === "best_problem_description" ||
    reportPostStep === "what_is_happening" ||
    reportPostStep === "submit_confirmation";
  const showSubmitButton = reportPostStep === "submit_confirmation";
  const showDoneButton = reportPostStep === "submit_success";

  return (
    <Container
      $withButton={showBackButton || showSubmitButton || showDoneButton}
    >
      {showTweakYourFeed && <TweakYourFeed />}
      {showBackButton && <FooterButtons.BackButton />}
      {showSubmitButton && <FooterButtons.SubmitButton />}
      {showDoneButton && <FooterButtons.DoneButton />}
    </Container>
  );
};

const Container = styled(FlexRowEnd)<{ $withButton: boolean }>(
  ({ theme, $withButton }) => `
  position: sticky;
  bottom: 0;
  padding: ${
    $withButton
      ? `${theme.spacing["spacing-6"].value}rem ${theme.spacing["spacing-8"].value}rem`
      : `3px ${theme.spacing["spacing-4"].value}rem ${theme.spacing["spacing-6"].value}rem ${theme.spacing["spacing-4"].value}rem`
  } ;
  gap: ${theme.spacing["spacing-2"].value}rem;
`
);
